import { getProductsEquipmentSuggestions } from '@/api/generated/products-placeholders/products-placeholders';
import type { EquipmentSuggestion } from '@/api/generated/schemas';
import { createLegacyEntitySelector, type LegacyEntityRef } from './createLegacyEntitySelector';

/** UI ref položky vybavení (equipment). */
export type EquipmentRef = LegacyEntityRef;

/**
 * Selektor vybavení nad `POST /api/products/equipment/suggestions`. Používá se v sekci Ubytování
 * detailu placeholderu ve `mode="multi"`.
 */
const equipment = createLegacyEntitySelector<EquipmentSuggestion>({
  fetch: getProductsEquipmentSuggestions,
  queryKeyPrefix: 'venua-planner.equipment',
  objectCategory: 'Equipment',
  columnHeaderKey: 'schemes.equipmentSelector.columns.name',
});

export const EquipmentSelector = equipment.Selector;
export const EquipmentSelectorField = equipment.Field;
